import React, { useContext } from "react";

// import PropTypes from "prop-types";
import ColourContext from "../../contexts/ColourContext";
import { colourThemes } from "../../styles/colourPalettes";

interface BackgroundProps {
  // colour: string;
}

const Background = () => {
  const { key } = useContext(ColourContext);
  const colour = colourThemes[key];
  return (
    <div
      style={{
        top: 0,
        left: 0,
        opacity: 0.3,
        position: "absolute",
        width: "100vw",
        height: "100vh",
        background: `linear-gradient(rgba(255,255,255,0) 0%, ${colour} 90%`,
        zIndex: -1,
      }}
    />
  );
};

Background.propTypes = {};
Background.defaultProps = {};

export default Background;
